<template>
	<div class="parts-locations-general-card-edit">
		<!-- Shared Settings Section -->
		<SectionContainer>
			<template #left>
				<h4>Shared Settings</h4>
			</template>
			<template #content>
				<label for="printInternalPartCost">
					<span>RO Print Internal Part Cost</span>
					<span>
						Affects Appointment; Estimate; and Repair Order"
					</span>
				</label>
				<Toggle
					id="printInternalPartCost"
					:labelInsideClassName="'toggle--label-in'"
					v-model="localData.sharedSettings.printInternalPartCost"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<label for="woRequiresEmail">
					<span>WO Requires Email</span>
					<span>
						Affects Appointment; Estimate; and Repair Order"
					</span>
				</label>
				<Toggle
					id="woRequiresEmail"
					:labelInsideClassName="'toggle--label-in'"
					v-model="localData.sharedSettings.woRequiresEmail"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<label for="printGMltw">
					<span>RO Invoice Print GM LTW</span>
					<span>
						Affects Appointment; Estimate; and Repair Order"
					</span>
				</label>
				<Toggle
					id="printGMltw"
					:labelInsideClassName="'toggle--label-in'"
					v-model="localData.sharedSettings.printGMltw"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<label for="includeWarrantyAmount">
					<span>Include Extended Service Amount</span>
					<span>
						Affects Appointment; Estimate; and Repair Order"
					</span>
				</label>
				<Toggle
					id="includeWarrantyAmount"
					:labelInsideClassName="'toggle--label-in'"
					v-model="localData.sharedSettings.includeWarrantyAmount"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<label for="includeExtendedServiceAmount">
					<span>Include Extended Service Amount</span>
					<span>
						Affects Appointment; Estimate; and Repair Order"
					</span>
				</label>
				<Toggle
					id="includeExtendedServiceAmount"
					:labelInsideClassName="'toggle--label-in'"
					v-model="
						localData.sharedSettings.includeExtendedServiceAmount
					"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<label for="printAuthAdditionsFormOnWO">
					<span>Print Authorized Additions Form on WO</span>
					<span>
						Affects Appointment; Estimate; and Repair Order"
					</span>
				</label>
				<Toggle
					id="printAuthAdditionsFormOnWO"
					:labelInsideClassName="'toggle--label-in'"
					v-model="
						localData.sharedSettings.printAuthAdditionsFormOnWO
					"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<Dropdown
					label="RO Invoice Print Labor"
					subLabel="Affects Estimate and RO"
					v-model="localData.sharedSettings.invoicePrintLabor"
					:options="invoicePrintLaborTypeOptions"
				/>
				<Dropdown
					label="RO Invoice Tech Info"
					subLabel="Affects Estimate and RO"
					v-model="localData.sharedSettings.invoiceTechInfo"
					:options="invoiceTechInfoTypeOptions"
				/>
			</template>
		</SectionContainer>
		<!-- RO Section -->
		<SectionContainer>
			<template #left>
				<h4>RO</h4>
			</template>
			<template #content>
				<Dropdown
					label="Print Prompt At Close"
					subLabel="Lorem ipsum ut semper et ipsum at cursus"
					v-model="localData.roSettings.printPromptAtClose"
					:options="printPromptAtCloseTypeOptions"
				/>
				<Dropdown
					label="WO Tech Info"
					subLabel="Lorem ipsum ut semper et ipsum at cursus"
					v-model="localData.roSettings.woTechInfo"
					:options="woTechInfoTypeOptions"
				/>
				<Dropdown
					label="Tech Name Format"
					subLabel="Lorem ipsum ut semper et ipsum at cursus"
					v-model="localData.roSettings.techNameFormat"
					:options="techNameFormatTypeOptions"
				/>
				<label for="printAuthorizedAdditionsFormOnWO">
					<span>Print Authorized Additions form on WO</span>
				</label>
				<Toggle
					id="printAuthorizedAdditionsFormOnWO"
					:labelInsideClassName="'toggle--label-in'"
					v-model="
						localData.roSettings.printAuthorizedAdditionsFormOnWO
					"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<label for="printBarcode">
					<span>RO Print Barcode</span>
					<span>Lorem ipsum ut semper et ipsum at cursus</span>
				</label>
				<Toggle
					id="printBarcode"
					:labelInsideClassName="'toggle--label-in'"
					v-model="localData.roSettings.printBarcode"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<label for="invoiceSubletInfo">
					<span>RO Invoice Sublet Info</span>
					<span>Lorem ipsum ut semper et ipsum at cursus</span>
				</label>
				<Toggle
					id="invoiceSubletInfo"
					:labelInsideClassName="'toggle--label-in'"
					v-model="localData.roSettings.invoiceSubletInfo"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<label for="woRequiresHatNumber">
					<span>WO Requires Hat Number</span>
					<span>Lorem ipsum ut semper et ipsum at cursus</span>
				</label>
				<Toggle
					id="woRequiresHatNumber"
					:labelInsideClassName="'toggle--label-in'"
					v-model="localData.roSettings.woRequiresHatNumber"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<label for="woRequiresEmail">
					<span>WO Requires Email</span>
					<span>Lorem ipsum ut semper et ipsum at cursus</span>
				</label>
				<Toggle
					id="woRequiresEmail"
					:labelInsideClassName="'toggle--label-in'"
					v-model="localData.roSettings.woRequiresEmail"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<label for="internalInclGLtrans">
					<span>Internal - Incl GL Trans</span>
					<span>Lorem ipsum ut semper et ipsum at cursus</span>
				</label>
				<Toggle
					id="internalInclGLtrans"
					:labelInsideClassName="'toggle--label-in'"
					v-model="localData.roSettings.internalInclGLtrans"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<section>
					<h6>Oil Change</h6>
					<Dropdown
						label="Label Line 1"
						subLabel="Lorem ipsum ut semper et ipsum at cursus"
						v-model="localData.roSettings.oilChange.line1"
						:options="lineTypeOptions"
					/>
					<Dropdown
						label="Label Line 2"
						subLabel="Lorem ipsum ut semper et ipsum at cursus"
						v-model="localData.roSettings.oilChange.line2"
						:options="lineTypeOptions"
					/>
					<Dropdown
						label="Label Line 3"
						subLabel="Lorem ipsum ut semper et ipsum at cursus"
						v-model="localData.roSettings.oilChange.line3"
						:options="lineTypeOptions"
					/>
					<Dropdown
						label="Label Line 4"
						subLabel="Lorem ipsum ut semper et ipsum at cursus"
						v-model="localData.roSettings.oilChange.line4"
						:options="lineTypeOptions"
					/>
					<Dropdown
						label="Label Months"
						subLabel="Lorem ipsum ut semper et ipsum at cursus"
						v-model="localData.roSettings.oilChange.lineMonths"
						:options="lineTypeOptions"
					/>
					<Dropdown
						label="Label Miles"
						subLabel="Lorem ipsum ut semper et ipsum at cursus"
						v-model="localData.roSettings.oilChange.lineMiles"
						:options="lineTypeOptions"
					/>
				</section>
				<section>
					<h6>Invoice Print Deferred Operations</h6>
					<Dropdown
						label="Invoice/Estimate Default Settings"
						v-model="
							localData.invoicePrintDeferredOperations
								.invoiceDefaultSettings
						"
						:options="invoiceDefaultSettingsTypeOptions"
					/>
					<label for="ro">
						<span>Repair Order</span>
					</label>
					<Toggle
						id="ro"
						:labelInsideClassName="'toggle--label-in'"
						v-model="localData.invoicePrintDeferredOperations.ro"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
					<label for="maintenanceMenu">
						<span>Maintenance Menu</span>
					</label>
					<Toggle
						id="maintenanceMenu"
						:labelInsideClassName="'toggle--label-in'"
						v-model="
							localData.invoicePrintDeferredOperations
								.maintenanceMenu
						"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
					<label for="multipointInspection">
						<span>Multi - Point Inspection</span>
					</label>
					<Toggle
						id="multipointInspection"
						:labelInsideClassName="'toggle--label-in'"
						v-model="
							localData.invoicePrintDeferredOperations
								.multipointInspection
						"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
				</section>
				<section>
					<h6>State Disclosures</h6>
					<Dropdown
						label="View State Disclosure"
						subLabel="Lorem ipsum ut semper et ipsum at cursus"
						v-model="
							localData.roSettings.stateDisclosures
								.stateDisclosuresStatement
						"
						:options="stateDisclosuresStatementTypeOptions"
					/>
					<Button
						className="btn--icon-only"
						iconClassName="icon-show"
						:iconBeforeLabel="true"
					/>
					<CheckboxGroup
						:items="stateDisclosuresMultiselectGroupItems"
						v-model="
							localData.roSettings.stateDisclosures
								.stateDisclosuresMultiselectGroup
						"
					/>
				</section>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import CheckboxGroup from '@/components/forms/selection-control/checkbox/checkbox-group';
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import Button from '@/components/forms/button/button';
import SectionContainer from '@/components/shells/section-container/section-container';
import _ from 'lodash';

export default {
	name: 'PartsLocationsGeneralCardEdit',
	components: { SectionContainer, Dropdown, Toggle, CheckboxGroup, Button },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			invoicePrintLaborTypeOptions: ['lorem', 'ipsum'],
			invoiceTechInfoTypeOptions: ['lorem', 'ipsum'],
			printPromptAtCloseTypeOptions: ['lorem', 'ipsum'],
			lineTypeOptions: ['lorem', 'ipsum'],
			woTechInfoTypeOptions: ['lorem', 'ipsum'],
			techNameFormatTypeOptions: ['lorem', 'ipsum'],
			invoiceDefaultSettingsTypeOptions: ['lorem', 'ipsum'],
			stateDisclosuresStatementTypeOptions: ['lorem', 'ipsum'],
			stateDisclosuresMultiselectGroupItems: [
				{
					disabled: false,
					label: 'Pre Work Order',
					modelValue: '',
					value: '1'
				},
				{
					disabled: false,
					label: 'Work Order',
					modelValue: '',
					value: '2'
				},
				{
					disabled: false,
					label: 'RO Invoice',
					modelValue: '',
					value: '3'
				},
				{
					disabled: false,
					label: 'Internal',
					modelValue: '',
					value: '4'
				}
			]
		};
	},
	created() {
		//console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.parts-locations-general-card-edit {
	&__item {
		display: block;
	}
}
</style>
